import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TableBody, TableHead, TableRow } from '@mui/material';
import { DenseHeaderTableCell, TableStyled } from './DocumentsStyles';

const DocumentsUploadTransitionsComponent = ({ t, stateTransitions }) => {
  return (
    <>
      <div style={{ width: '100%' }}>
        <TableStyled>
          <TableHead>
            <TableRow>
              <DenseHeaderTableCell>{t('OfferEdit.Documents.Transitions.State')}</DenseHeaderTableCell>
              <DenseHeaderTableCell>{t('OfferEdit.Documents.Transitions.Date')}</DenseHeaderTableCell>
              <DenseHeaderTableCell>{t('OfferEdit.Documents.Transitions.User')}</DenseHeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stateTransitions?.map(n => {
              return (
                <TableRow key={n.fileId}>
                  <DenseHeaderTableCell>{n.stateName}</DenseHeaderTableCell>
                  <DenseHeaderTableCell>
                    {t('DATE_FORMAT', { date: { value: n.transitionMoment, format: 'DD.MM.YYYY HH:mm:ss' } })}
                  </DenseHeaderTableCell>
                  <DenseHeaderTableCell>{n.userName}</DenseHeaderTableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </TableStyled>
      </div>
    </>
  );
};

DocumentsUploadTransitionsComponent.propTypes = {
  t: PropTypes.func.isRequired,
  stateTransitions: PropTypes.array
};

export default withTranslation()(DocumentsUploadTransitionsComponent);
